export default __webpack_public_path__ + "static/media/criticalcare.1bc25fc5.svg";